<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Tank Report"  path="frontdash"/>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                            <div class="card-header">
                                <div class="row">
                                  
                                    <div class="col-md-2 col-12 position-relative"  >
                                        <label class="form-label">User Nagarpalika</label>
                                        <select class="form-select" required="" v-model="filter.np"  @change="getAgents($event)">
                                            <option selected=""   disabled="" value="0">Choose...</option>
                                            <template v-for="(item ,index)  in nagarpalika_list" :key="item.id">
                                                  <option :value="item.id">{{item.name}}</option>   
                                            </template> 
                                        </select>
                                    </div>
                                    
                                     <div class="col-md-2 col-12 position-relative"  >
                                        <label class="form-label">Agents</label>
                                        <select class="form-select" required="" v-model="filter.agent">
                                            <option selected=""   value="0">ALL</option>
                                            <template v-for="(item ,index)  in filter_agent_list" :key="item.id">
                                                  <option :value="item.id">{{item.empname}} ({{item.empcode}})</option>   
                                            </template> 
                                        </select>
                                    </div>
                                     <div class="col-md-2 col-12 position-relative">
                                            <label class="form-label">Ward Name</label>
                                            <select class="form-select" required="" v-model="filter.actual_ward">
                                                <option selected="" value="0">ALL</option>
                                                <template v-for="(item ,index)  in filter_ward_list" :key="item">
                                                    <option :value="item.actual_ward">{{item.actual_ward}}</option>
                                                </template>
                                            </select>
                                        </div>
                                    
                                    <div class="col-xl-2 col-md-2 col-12" >
                                        <label class="form-label"><span class="f-w-500 f-14">From Date</span></label>
                                        <input class="form-control" type="date" v-model="filter.fromdate" >
                                    </div>
                                     <div class="col-xl-2 col-md-2 col-12" >
                                        <label class="form-label"><span class="f-w-500 f-14">To Date</span></label>
                                        <input class="form-control" type="date" v-model="filter.todate" >
                                    </div>
                                     <div class="col-xl-2 col-sm-12 col-12" >
                                        <button class="btn btn-primary" @click="filterReport"><i class="fa fa-filter"></i> Filter</button>
                                        
                                    </div>
                                </div>
                            </div>
                        <div class="card-body badge-spacing">
                            <div v-if="loading" >Data is Loading....</div>
                            <div v-else class="table-responsive custom-scrollbar">
                                <button class="dt-button buttons-csv buttons-html5" @click="exportKML()" v-if="userDetails.emprole!=4"> KML Report</button>
                                <table class="table display datatable" id="basic-1">
                                    <thead>
                                        <tr>
                                                <th>Sr.No</th>
                                             	<th>Survey Date</th>
                                                <th>Agent Name</th>
                                                <th>सेप्टिक टॅंक सर्व्हे	नागरिक/ आस्थापनेचे नाव(Name of Citizen / Hotel / Office / School / Society/Other)</th>
                                                <th>वॉर्ड नं. (Ward No)</th>
                                                <th>घर क्रमांक ( Property Number)</th>
                                                <th>फोन नंबर (Phone Number)</th>
                                                <th>पत्ता(Address)</th> 
                                            <th>Ward Name</th>
                                                <th>Tank lattitude</th> 
                                                <th>Tank longitude</th> 
                                                <th>आस्थापनेचा प्रकार(Establishment)</th>
                                                <th>सोसायटी मधील घरांची संख्या</th>
                                                <th>आपल्याकडे सेप्टिक टॅंक ची स्थापना केली आहे का? (Type of Sanitation Connection)</th>
                                                <th>सेप्टिक टॅंक उपसा(Septic Tank Emptied At)</th> 
                                                <!-- <th>bird_nest</th>-->
                                                <th>Image</th>
                                                <th>सौर पॅनेल (Solar Panels)</th>
                                                <th>Ramark</th>
                                                <th>Image</th>
                                                
                                                <th>सौर वॉटर हीटर ( Solar Water Hearter)</th>
                                                <th>Ramark</th>
                                                <th>Image</th>
                                                
                                                <th>पावसाचे पाणी साठवण प्रणाली (Rain Water Harvesting System)</th>
                                                <th>Ramark</th>
                                                <th>Image</th>
                                                <th>इलेकट्रीक वाहन (EV Vehicle)</th>
                                                <th>Ramark</th>
                                                <th>Image</th>
                                                
                                                
                                                
                                                <th class="hide">ID</th>
                                                <th>Edit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr  v-for="(item ,index)  in treereports" :key="item.id" >
                                             <th>{{index+1}}</th>
                                             <th>{{item.iddate}}</th>
                                                <th>{{item.agent_name}}</th>
                                                <td>{{item.name}}</td>
                                                <td>{{item.ward}}</td>
                                                <td>{{item.property}}</td>
                                                <td>{{item.phone}}</td>
                                                <td>{{item.address}}</td> 
                                                <td>{{item.actual_ward}}</td>
                                                <td>{{item.tank_location_lat}}</td> 
                                                <td>{{item.tank_location_lng}}</td> 
                                                <td>{{item.establishment}}</td>
                                                <td>{{item.society}}</td>
                                                <td>{{item.sanitation}}</td>
                                                <td>{{item.empied}}</td> 
                                                <td class=""> 
                                                    <a @click="show_image(item.tank_image)" target="_blank"><i class="fa fa-image"></i></a>
                                                    <span class="hide">{{$hostname+''+item.tank_image}}</span>
                                                </td>
                                                
                                                
                                                <td>{{item.solar}}</td> 
                                                <td>{{item.solar_remark}}</td> 
                                                <td class="">  
                                                    <a @click="show_image(item.solar_pic)" target="_blank"><i class="fa fa-image"></i></a>
                                                    <span class="hide">{{$hostname+''+item.tank_image}}</span>
                                                </td>
                                                
                                                <td>{{item.sourheater}}</td> 
                                                <td>{{item.sourheater_remark}}</td> 
                                                <td class="">  
                                                    <a @click="show_image(item.sourheater_img)" target="_blank"><i class="fa fa-image"></i></a>
                                                    <span class="hide">{{$hostname+''+item.sourheater_img}}</span>
                                                </td>
                                                
                                                <td>{{item.rainwater}}</td> 
                                                <td>{{item.rain_remark}}</td> 
                                                <td class=""> 
                                                    <a @click="show_image(item.water_pic)" target="_blank"><i class="fa fa-image"></i></a>
                                                    <span class="hide">{{$hostname+''+item.water_pic}}</span>
                                                </td>
                                                
                                                <td>{{item.ev}}</td> 
                                                <td>{{item.ev_remark}}</td> 
                                                <td class="">  
                                                    <a @click="show_image(item.ev_pic)" target="_blank"><i class="fa fa-image"></i></a>
                                                    <span class="hide">{{$hostname+''+item.ev_pic}}</span>
                                                </td>
                                                
                                                <td class="hide">{{item.id}}</td>
                                                <td><span @click="" v-show="item.isEdit==1"><i class="fa fa-edit"></i></span></td>
                                                </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->
 
</template>
<style scopped>
    th{
            text-transform: capitalize;
    }
    .table th, .table td{
        padding: 0.4em !important;
    }
    .hide{
        display: none;
    }
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue'; 
import axios from 'axios';
const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'TankReport', 
    components: {
        PageTitle
    }, mounted() {
         if (this.$route.query.q) {
                this.getBasics(1);
            }else {
               this.getBasics(0);
            }
        

    }, data() {
        return {
          filter_agent_list: [],
          agent_list: [],
          nagarpalika_list: [],
                filter_ward_list: [],

                ward_list: [],
          treereports: [],
          treereports_full: [],
          fromDate: '',
          toDate: '',
          loading:true,
          userDetails:{"emprole":0},
          datatable:null,
          filter:{'np':'','agent':'','fromdate':'','todate':''}
        }
    },
   
    methods: { 
        
        show_image(img){ 
            window.open(this.$hostname+''+img, '_blank');
        },
        
        getAgents(event){ 
             var np_id=event.target.value;
              this.filter_agent_list=this.agent_list.filter(item => item.empdept === np_id);
              this.filter_ward_list = this.ward_list.filter(item => item.nagarpalikaid === np_id);
             
              
        },
        filterReport() {
               var self = this; 
                self.loading=true;
                 axios.post('getTankSurveyReport', { filter: self.filter })
                    .then(function (response) {
                         $(".datatable").DataTable().destroy();
                        self.treereports = response.data.survey_report; 
                        self.nagarpalika_list = response.data.nagarpalika_list; 
                         self.loading=false;
                    }).then(()=>{
                          if(self.userDetails.emprole==4){
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
                }else{
                         self.datatable= $(".datatable").DataTable({
                           dom: 'Bfrtip',
                           buttons: [  'excel', 'print','csv'],
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
                }
                    });
        },
        async getBasics(today) {
            var self = this;
            await  axios.post('getTankSurveyReport',{today:today}).then(function (response) {
                // self.treereports = response.data.survey_report; 
                self.userDetails = response.data.userDetails;   
                self.nagarpalika_list = response.data.nagarpalika_list; 
                self.agent_list = response.data.agent_list; 
                self.ward_list = response.data.ward_list; 
                // self.treereports=self.treereports_full;//.slice(0, 1000);
                self.loading=false;
                window.scrollTo(0, 0);
            }).then(()=>{
                if(self.userDetails.emprole==4){
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
                }else{
                         self.datatable= $(".datatable").DataTable({
                           dom: 'Bfrtip',
                           buttons: [  'excel', 'print','csv'],
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
                }
            });
        },
        
        
        
        
        exportKML(){ 
                    var data = this.datatable.rows({ search: 'applied' }).data();
                    var kml = '<?xml version="1.0" encoding="UTF-8"?>\n' +
                              '<kml xmlns="http://www.opengis.net/kml/2.2">\n' +
                              '  <Document>\n';
    
                    data.each(function (value, index) {
                        var name = value[3]+'('+value[12]+')';
                       var latlng = value[8]+','+value[7];
                       // var lng = value[2];
    
              kml += '  	         <Placemark>\n'+
                     '      				<name>\n'+
                     '      					<![CDATA[Row: '+(1+index)+']]>\n'+
                     '      				</name>\n'+
                     "      				<Snippet maxLines='0'></Snippet>\n"+
                     '      				<styleUrl>#0_0</styleUrl>\n'+
                     '      				<ExtendedData></ExtendedData>\n'+
                     '      				<LookAt>\n'+
                     '      					<longitude>'+value[8]+'</longitude>\n'+
                     '      					<latitude>'+value[7]+'</latitude>\n'+
                     '      					<range>1000</range>\n'+
                     '      					<altitudeMode>relativeToGround</altitudeMode>\n'+
                     '      					<tilt>0</tilt>\n'+
                     '      					<heading>0</heading>\n'+
                     '      				</LookAt>\n'+
                     '      				<Point>\n'+
                     '      					<altitudeMode>clampToGround</altitudeMode>\n'+
                     '      					<extrude>0</extrude>\n'+
                     '      					<coordinates>'+latlng+',0</coordinates>\n'+
                     '      				</Point>\n'+
                     '      				<description>\n'+
                     "      					<![CDATA[<style type='text/css'>*{font-family:Verdana,Arial,Helvetica,Sans-Serif;box-sizing:border-box;padding:0px;margin:0px}table{border-collapse:collapse;border-spacing:0px;margin:2px}.trb{background-color:#ddffdd}.ch{vertical-align:top;padding-left:10px;white-space:nowrap}.cv{vertical-align:top;padding-left:6px;padding-right:10px;white-space:nowrap}.cw{vertical-align:top;padding-left:6px;padding-right:10px;width:600px}</style><table><tr class='trb'><td class='ch'><b>Entry Id</b></td><td class='cv'>"+value[19]+"</td></tr><tr><td class='ch'><b>Survey Date</b></td><td class='cv'>"+value[1]+"</td></tr><tr class='trb'><td class='ch'><b>Agent Name</b></td><td class='cv'>"+value[2]+"</td></tr><tr><td class='ch'><b>local_name</b></td><td class='cv'>"+value[3]+"</td></tr><tr class='trb'><td class='ch'><b>comman_name</b></td><td class='cv'>"+value[4]+"</td></tr><tr><td class='ch'><b>botnical_name</b></td><td class='cv'>"+value[5]+"</td></tr><tr class='trb'><td class='ch'><b>other_name</b></td><td class='cv'>"+value[6]+"</td></tr><tr><td class='ch'><b>Latitude</b></td><td class='cv'>"+value[7]+"</td></tr><tr class='trb'><td class='ch'><b>Longitude</b></td><td class='cv'>"+value[8]+"</td></tr><tr><td class='ch'><b>girth</b></td><td class='cv'>"+value[9]+"</td></tr><tr class='trb'><td class='ch'><b>height</b></td><td class='cv'>"+value[10]+"</td></tr><tr><td class='ch'><b>Conopy diameter</b></td><td class='cv'>"+value[11]+"</td></tr><tr class='trb'><td class='ch'><b>tree_condition</b></td><td class='cv'>"+value[12]+"</td></tr><tr><td class='ch'><b>tree_balance</b></td><td class='cv'>"+value[13]+"</td></tr><tr class='trb'><td class='ch'><b>remark</b></td><td class='cv'>"+value[14]+"</td></tr><tr><td class='ch'><b>ownership</b></td><td class='cv'>"+value[15]+"</td></tr><tr class='trb'><td class='ch'><b>society_name</b></td><td class='cv'>"+value[16]+"</td></tr><tr><td class='ch'><b>road_name</b></td><td class='cv'>"+value[17]+"</td></tr><tr class='trb'><td class='ch'><b>bird_nest</b></td><td class='cv'>"+value[18]+"</td></tr><tr><td class='ch'><b>ID</b></td><td class='cv'>"+value[19]+"</td></tr></table>]]>\n"+
                     
                     '      				</description>\n'+
                     '      			</Placemark> \n';
                    });
    
                    kml += '  </Document>\n' +
                           '</kml>';
    
                    var blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'data.kml';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
        },
          exportKMLNew(){ 
                    var data = this.datatable.rows({ search: 'applied' }).data();
                    var kml = '<?xml version="1.0" encoding="UTF-8"?>\n' +
                              '<kml xmlns="http://www.opengis.net/kml/2.2">\n' +
                              '  <Document>\n'+
                              '<name>Trees in Solapur</name>\n'+
                              '<description>Locations of 10 trees in Solapur city</description>\n';
    
                    data.each(function (value, index) {
                        var name = value[3]+'('+value[12]+')';
                        var latlng = value[7]+','+value[8];
                       // var lng = value[2];
    
                        kml += '    <Placemark>\n' +
                               '      <name>' + name + '</name>\n' + 
                               '      <Point>\n' +
                               '        <coordinates>' + latlng + ',0</coordinates>\n' +
                               '      </Point>\n' +
                               '    </Placemark>\n';
                    });
    
                    kml += '  </Document>\n' +
                           '</kml>';
    
                    var blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'data.kml';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
        },
         editSurveyReport(item_id){
             this.$router.push({ name: "editsurvey" , query: { q: item_id} }); 
        }
         
    }
}
</script>
